(() => {
  if (customElements.get('freddin-policy-ack')) return;
  class FreddinPolicyAck extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('input[type="checkbox"]');
      if (!input || input.dataset.ackBound) return;
      input.dataset.ackBound = 'true';
      input.addEventListener('change', () => {
        input.removeAttribute('aria-invalid');
        this.querySelector('[role="alert"]').hidden = true;
      });
    }
  }
  customElements.define('freddin-policy-ack', FreddinPolicyAck);
  function validate(form, event) {
    if (!form) return;
    const inputs = Array.from(document.querySelectorAll('freddin-policy-ack input[type="checkbox"]'))
      .filter(input => input.form === form);
    const missing = inputs.find(input => !input.checked);
    if (!missing) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    missing.setAttribute('aria-invalid', 'true');
    missing.closest('freddin-policy-ack').querySelector('[role="alert"]').hidden = false;
    missing.focus();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest && event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (button) validate(button.form, event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter && event.submitter.name === 'checkout') validate(event.target, event);
  }, true);
})();